import Vue from 'vue'
import VueRouter from 'vue-router'
//import Home from '../views/Home.vue';
const Home = () => import(/* webpackChunkName: "home" */ '../views/Home.vue')
const Map = () => import(/* webpackChunkName: "Map" */ '../views/Map.vue')
const LastImages = () => import(/* webpackChunkName: "LastImages" */ '../views/LastImages.vue')
const Filtering = () => import(/* webpackChunkName: "Filtering" */ '../views/Filtering.vue')
const DataFiltering = () =>
    import(/* webpackChunkName: "DataFiltering" */ '../views/DataFiltering.vue')
const PageNotFound = () =>
    import(/* webpackChunkName: "PageNotFound" */ '../views/PageNotFound.vue')
const CompareImages = () =>
    import(/* webpackChunkName: "CompareImages" */ '../views/CompareImages.vue')

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'home',
        component: Home
    },
    {
        path: '/home',
        name: 'Home_link',
        component: Home
    },
    {
        path: '/mapview',
        name: 'mapview',
        component: Map
    },
    {
        path: '/lastimages',
        name: 'lastimages',
        component: LastImages
    },
    {
        path: '/filtering',
        name: 'filtering',
        component: Filtering
    },
    {
        path: '/datafiltering',
        name: 'datafiltering',
        component: DataFiltering
    },
    {
        path: '/compareimages',
        name: 'compareimages',
        component: CompareImages
    },
    {
        path: '/termsofuse',
        name: 'termsofuse',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '../views/TermsUse.vue')
    },
    {
        path: '/about',
        name: 'about',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
    },
    { path: '*', component: PageNotFound }
]

const router = new VueRouter({
    base: process.env.VUE_APP_ROUTES_PATH,
    routes,
    mode: 'history'
})

export default router
